module.exports = __webpack_public_path__ + "img/bgtop-com.a4f24f1e.jpg";